<template>
  <div class="custom-card">
    <card-type
      :cardType="4"
      @changeOrderCardDetailClick="changeOrderCardDetailClick"
      @changeOrderCardTypeClick="changeOrderCardTypeClick"
      :cardList="cardList"
    ></card-type>
    <cardDetailDialog
      :cardInfo="currentCardInfo"
      @changeDialogVisible="changeDialogVisible"
      :dialogVisible="dialogVisible"
    ></cardDetailDialog>
  </div>
</template>

<script lang="js">
import { defineComponent, reactive, ref } from 'vue'
import CardType from '../../../base-ui/card-type/card-type.vue'
import { useState } from '@/hooks'
import cardDetailDialog from '../../../base-ui/card-detail-dialog/card-detail-dialog'
import { isNewUser } from '@/service/main/reserve'
import { useRoute } from 'vue-router'
import emitter from '@/utils/eventbus'
import { ElMessage } from 'element-plus'

export default defineComponent({
  props: {
    cardList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  components: {
    CardType,
    cardDetailDialog
  },
  setup() {
    const route = useRoute()
    const currentCardInfo = ref({})
    const dialogVisible = ref(false)
    const changeDialogVisible = (flag) => {
      dialogVisible.value = flag
    }

    const changeOrderCardDetailClick = item => {
      currentCardInfo.value = item
      dialogVisible.value = true
    }

    const changeOrderCardTypeClick = async item => {
      const res = await isNewUser(route.query.userId)
      // if (res.data == item.buyerRoleFlag) {
      //   emitter.emit('changeDiscountCardClick', item)
      // } else {
      //   ElMessage({
      //     message: '该用户无购买权限!',
      //     type: 'warning',
      //   })
      // }
      // console.log(item);
      emitter.emit('changeDiscountCardClick', item)
    }

    return {
      currentCardInfo,
      dialogVisible,
      changeDialogVisible,
      changeOrderCardDetailClick,
      changeOrderCardTypeClick,

    }

  }
})
</script>

<style scoped lang="less">
.custom-card {
}
</style>
